<template>
  <div>
    <div id="survey-response-card" v-show="isCardActiveLocal" class="overflowCardScroll contentCards" vs-align="center">
      <div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <div class="flex flex-wrap items-center justify-center pb-2">
                <h3>Survey Review</h3>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <div class="flex flex-wrap items-center justify-center pb-2">
              <div class="final-result pass">
                <p><strong>Thank You!</strong></p>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div v-show="isTimeUpLabelShown" class="vx-col mx-auto">
            <p style="color: red"><strong>Your time is up!</strong></p>
          </div>
        </div>
        
      </div>
      <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
        <img id="next-task-arrow" @click="nextTask" v-show="isCardActiveLocal && !isStudentProp && !styleB" src="../../assets/images/digi-next-arrow.png"/>

      <div class="completebuttonstylebupload pt-20">
        <div class="flex next_btns__container justify-center">
          <vs-button v-show="styleB" id="completetask-btn" class="vs-con-loading__container next_btns clickbuttonactive" 
          ref="submit_btn" icon-pack="feather" icon="icon-arrow-right" icon-after
          @click="nextTask">
          Complete
          </vs-button>
        </div>
      </div>
      
    </div>

    <vs-popup title="Having some problems?" :active.sync="helpPopupActive">
      <p class="pb-2">Please tell us about the issues you are experiencing:</p>
      <vs-textarea v-model="errorData.userMessage" />
      <p class="pb-2">Your WhatsApp number:</p>
      <vs-input autocomplete="off" v-validate="'digits:10'" name="WhatsApp number" v-model="errorData.whatsappNumber" />
      <span class="text-danger text-sm" v-show="errors.has('WhatsApp number')">{{ errors.first('WhatsApp number') }}</span>
      <div class="mt-3">
        <vs-button color="success" class="float-right" @click="submitIssue">Submit</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
  import { setInterval } from 'timers';

  export default {
    components: {
      
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      quizResponse: {
        type: Object,
        required: false
      },
      cardHeight: {
        type: Number,
        required: false,
      },
      cardWidth: {
        type: Number,
        required: false,
      },
      isStudentProp: {
        type: Boolean,
        required: false
      },
      errorDataProp: {
        type: Object,
        required: false
      },
      taskIdProp: {
        type: Number,
        required: false,
      },
      styleB: {
        type: Boolean,
        required: false
      },
    },
    data() {
      return {
        isTimeUpLabelShown: false,
        helpPopupActive: false,
        errorData: {
          userId: null,
          taskId: null,
          userMessage: "",
          osName: "",
          osVersion: "",
          browserName: "",
          browserVersion: "",
          navigatorUserAgent: "",
          navigatorAppVersion: "",
          navigatorPlatform: "",
          navigatorVendor: "",
          isMobile: false,
          whatsappNumber: ""
        }
      }
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.quizResponse.timeUp == 1){
            self.isTimeUpLabelShown = true;
          }
        }
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) { }
      },
    },
    methods: {
      nextTask() {
        var self = this;
        if(self.styleB){var timeCapture = null;
          if (self.$route.query.timeCapture) {
            timeCapture = JSON.parse(self.$route.query.timeCapture);
          }
          if (self.$route.query.outcome) {
            self.$router.push({ name: "Gen2OutcomeTasks", query: { moduleId: self.$route.params.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome, timeCapture: JSON.stringify(timeCapture) }});
          } else {
            if(self.$route.params.styleB)
              self.$router.push({ name: 'LearningStyleBViewer', params: { moduleId: self.$route.params.moduleId, checkTimeCapture: true }})
            else
              self.$router.push('/menu');
          }
        }
        else {
          this.$emit("nextTask");
        }
      },
      submitIssue() {
        var self = this;
        self.helpPopupActive = false;

        self.errorData.osName = self.errorDataProp.osName;
        self.errorData.osVersion = self.errorDataProp.osVersion;
        self.errorData.browserName = self.errorDataProp.browserName;
        self.errorData.browserVersion = self.errorDataProp.browserVersion;
        self.errorData.navigatorUserAgent = self.errorDataProp.navigatorUserAgent;
        self.errorData.navigatorAppVersion = self.errorDataProp.navigatorAppVersion;
        self.errorData.navigatorPlatform = self.errorDataProp.navigatorPlatform;
        self.errorData.navigatorVendor = self.errorDataProp.navigatorVendor;

        self.errorData.taskId = self.taskIdProp;
        self.errorData.isMobile = self.isMobile();
        
        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Issue submitted!",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check'
          });
        };

        self.$ajaxPost(self, "Student/LogError", self.errorData, onSuccess);
      }
    }
  };
</script>

<style lang="scss">

.next_btns__container {
  .next_btns {
    .vs-button--text {
      text-transform: uppercase !important;
    }

    .vs-icon {
      font-size: 1.2rem !important;
    }

    width: 100% !important;
  }

  #nexttask-btn {
    width: 13% !important;
    border-radius: 25px !important;
    background-image: linear-gradient(#1c80c4,  #2367a7) !important;
  }

  #completetask-btn {
    width: 225px !important;
    border-radius: 25px !important;
    background-image: linear-gradient(266deg, rgba(43,55,43,1) 0%, rgba(68,198,70,1) 78%) !important;
  }

  @media screen and (max-width: 900px) {
    #nexttask-btn {
      width: 45% !important;
    }

    #completetask-btn {
      width: 45% !important;
    }
  }

  @media screen and (max-width: 700px) {
    #nexttask-btn {
      width: 50% !important;
    }

    #completetask-btn {
      width: 50% !important;
    }
  }
}

  #review-answer {
    height: 100px;
  }

  #survey-response-card {
    position: relative;

    .vx-card__collapsible-content.vs-con-loading__container {
      position: unset;
    }
  }

  .vs-button-light.vs-button-border:hover, .vs-button-light.vs-button-flat:hover {
    background: rgba(245, 245, 245, 0.3) !important;
  }

  #survey-response-card.overflowCardScroll {
    overflow-x: hidden !important;
    overflow-y: hidden !important;
  }

  .contentCards {
    margin: auto;
  }

  #next-task-arrow {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 99999;
    width: 50px;
    margin-bottom: 5px;
    margin-right: 5px;
  }

  #next-task-arrow:hover {
    width: 53px;
    cursor: pointer;
  }

  #next-task-arrow:active {
    width: 50px;
    cursor: pointer;
    opacity: 0.8;
  }

  @media screen and (max-width: 900px) {
    #next-task-arrow {
      width: 35px;
      position: absolute;
      margin-bottom: 2px;
      margin-right: 2px;
    }

    #next-task-arrow:hover {
      width: 38px;
      cursor: pointer;
    }

    #next-task-arrow:active {
      width: 35px;
      cursor: pointer;
      opacity: 0.8;
    }
  }
</style>
